<template>
    <section class="live-list">
        <ul class="nav nav-tabs justify-content-around">
            <li class="nav-item" v-for="tab in tabs">
                <a class="nav-link" :class="{ 'active': tab.id === tabIndex }" :href='`#tab-${tab.id}`'
                    data-toggle="tab" @click="switchTab(tab.id)">{{ characters[tab.type+'_type'] }}</a>
            </li>
        </ul>
        <ul id="live-list-ticket" class="live-list">
            <li v-for="live in liveList" class="screen-transition" @click="select(live.live_id, $event)">
                <!--<div class="live-title">{{ live.title }}</div>
                <div><img src="/image/icons/next.png"></div>-->

                    <div class="post-title">
                        <h3>{{ live.title }}</h3>
                        <p class="category" v-if="live.description != ''">
                            <span v-if="lang==ja">アーカイブ配信期間</span>
                            <span v-if="lang==en">Archive Delivery Duration</span>
                            ：{{ live.description }}
                        </p>
                        <p class="price" v-if="live.exist_ticket == true">@{{ live.price }}円</p>
                    </div>
                    <p v-if="live.exist_ticket == true && live.purchase == true" class="buy_check true">
                        <span v-if="lang=='ja'">購入済</span>
                        <span v-if="lang=='en'">Purchased</span>
                    </p>
                    <p v-if="live.exist_ticket == true && live.purchase == false" class="buy_check false">
                        <span v-if="lang=='ja'">未購入</span>
                        <span v-if="lang=='en'">Not Purchased</span>
                    </p>
            </li>
        </ul>
    </section>
</template>

<script>
import newsVue from './news.vue';
    export default {
        name: "live-list-ticket",
        props: ['json_characters', 'lang'],
        data: function () {
            return {
                liveList: [],
                tabIndex: null,
                tabs: [
                    {id: 0, title: 'all', type: 'all'},
                    {id: 1, title: 'live', type: 'live'},
                    {id: 2, title: 'archive', type: 'archive'},
                ],
                characters: Object,
            }
        },
        mounted() {
            let tabIndex;
            if (localStorage.getItem('live-tabIndex') === null) {
                tabIndex = 0;
            } else {
                tabIndex = Number(localStorage.getItem('live-tabIndex'));
            }
            this.tabIndex = tabIndex;
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            switchTab: function (id) {
                this.tabIndex = id;
            },
            select: function (s, event) {
                if (s) {
                    const id = String(s);
                    location.href = `/live?live_id=${id}`;
                }
            },
        },
        watch: {
            tabIndex: function (newIndex, oldIndex) {
                localStorage.setItem('live-tabIndex', newIndex);

                let type;
                switch (newIndex) {
                    case 0:
                        type = '';
                        break;
                    default:
                        let tab = this.tabs[newIndex];
                        console.log(tab);
                        type = '/'+tab.type;
                        console.log(type);
                        break;
                }
                axios.default
                    .get('/live/list_ticket/get' + type)
                    .then(response => {
                        this.liveList = response.data;
                    });
            },
        }
    }
</script>

<style scoped>

</style>
